import assign from "object-assign";
import PropTypes from "prop-types";
import { isObject } from "../flip/utilities";
export var getSpringInterface = function getSpringInterface() {
  return {
    stiffness: PropTypes.number,
    damping: PropTypes.number,
    overshootClamping: PropTypes.bool
  };
}; // adapted from
// https://github.com/chenglou/react-motion/blob/master/src/presets.js

export var springPresets = {
  noWobble: {
    stiffness: 200,
    damping: 26
  },
  gentle: {
    stiffness: 120,
    damping: 14
  },
  wobbly: {
    stiffness: 180,
    damping: 12
  },
  stiff: {
    stiffness: 260,
    damping: 26
  }
};
export var getSpringConfig = function getSpringConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      flipperSpring = _ref.flipperSpring,
      flippedSpring = _ref.flippedSpring;

  var normalizeSpring = function normalizeSpring(spring) {
    if (isObject(spring)) return spring;else if (springPresets[spring]) return springPresets[spring];else return {};
  };

  return assign({}, springPresets.noWobble, normalizeSpring(flipperSpring), normalizeSpring(flippedSpring));
};